exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".msgDio[data-v-2ed2db44] .el-dialog__header{border-bottom:0}.msgDio div[data-v-2ed2db44]{text-align:center;line-height:30px}.btns[data-v-2ed2db44]{text-align:center}\n", ""]);

// exports
